import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20luxurious%20bedroom%20setting%20with%20silk%20sheets%20in%20cream%20and%20deep%20burgundy%20tones%2C%20soft%20warm%20candlelight%20glow%2C%20rose%20petals%20scattered%20on%20the%20bed%2C%20sophisticated%20sensual%20atmosphere%2C%20premium%20lifestyle%20photography%2C%20editorial%20quality%2C%20rich%20textures%2C%20dark%20moody%20lighting%20with%20warm%20golden%20highlights&width=1920&height=1080&seq=hero-main-01&orientation=landscape"
          alt="臻品阁 - 高品质成人精品"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <p className="text-accent-300 text-xs md:text-sm font-label tracking-[0.3em] uppercase mb-3 md:mb-4 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]">
          甄选全球 · 品质私享
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-background-50 mb-4 md:mb-6 max-w-3xl leading-tight opacity-0 animate-[fadeInUp_0.8s_ease-out_0.15s_forwards]">
          探索顶级成人精品
          <br />
          <span className="text-accent-300">品质生活从这里开始</span>
        </h1>
        <p className="text-background-300/90 text-sm md:text-base max-w-lg mb-6 md:mb-8 opacity-0 animate-[fadeInUp_0.8s_ease-out_0.3s_forwards]">
          安全私密、品质保障，专业选品团队为您甄选全球高品质成人精品，让每一次体验都臻于完美
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_0.45s_forwards]">
          <Link
            to="/category"
            className="px-8 py-3 text-sm font-label font-medium whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            探索精品系列
          </Link>
          <Link
            to="/articles"
            className="px-8 py-3 text-sm font-label font-medium whitespace-nowrap rounded-full border border-background-300/40 text-background-100 hover:bg-background-50/10 transition-all duration-300 cursor-pointer"
          >
            阅读精选文章
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-xs text-background-300/70 font-label tracking-wider">向下探索</span>
        <i className="ri-arrow-down-line text-background-300/70" />
      </div>
    </section>
  );
}